




import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { DxTreeList } from 'devextreme-vue/tree-list';
import {
    CONTRACTS,
    EventsServiceContract,
    Events,
} from '@/core/contracts';
import { localize } from '@/core/filters';
import { ContextsState } from '@/store';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { DataSource } from '@/types';
import {
    Tree,
    TreeConfig,
    TreeComponentProps,
} from './types';
import defaultTreeConfig from './defaultTreeConfig';

@Component({
    components: {
        DxTreeList,
    },
})
export default class TreeComponent extends Vue implements TreeComponentProps {
    @Prop({ type: String, required: true }) public treeKey!: string;
    @Prop({ type: [Object, Array], required: true }) public dataSource!: DataSource;
    /**
     * TableConfig object, passed down from parent component
     * Will be merged with local computedTableConfig and deep merged with it
     *
     * @param {Partial<TreeConfig>} treeConfig Partial custom tree config
     */
    @Prop({ type: Object, required: false }) public treeConfig?: Partial<TreeConfig>;

    public async mounted() {
        // raise instance of the table up to parent
        this.$emit('setTreeInstance', this.treeInstance);
    }

    public get computedTreeConfig(): TreeConfig {
        return Object.assign(
            {
                dataSource: this.dataSource,
            },
            defaultTreeConfig(this),
            this.treeConfig,
        );
    }

    public get treeInstance(): Tree {
        const element = this.$refs['tree-list'] as unknown;
        return (element as DxTreeList).instance!;
    }

    /**
     * Flag that the user interacts with the table (made any changes that should not be lost)
     *
     * @returns {boolean} If instance have modified rows
     */
    private get isEditingNow(): boolean {
        const { treeInstance } = this;
        const haveModifiedItems = treeInstance.getSelectedRowsData().length > 0;

        return haveModifiedItems;
    }

    private resized() {
        setTimeout(this.updateScrollbars, 500);
    }

    private updateScrollbars() {
        this.treeInstance.repaintRows([0]);
    }

    private onProcessingFinishedEvent({ contextId }: any): void {
        if (Number(ContextsState.currentContextId) === Number(contextId) && !this.isEditingNow) {
            this.refreshTable();
        }
    }

    private refreshTable(): void {
        this.treeInstance.refresh();
    }

    private clearAllFilters(): void {
        const { treeInstance, computedTreeConfig } = this;
        const { customSave } = computedTreeConfig.stateStoring!;
        treeInstance.clearFilter();
        if (typeof customSave === 'function') {
            customSave(treeInstance.state());
        }
    }
}
